// extracted by mini-css-extract-plugin
module.exports = {"appIcon":"style_appIcon__pzIOj","large":"style_large__L9YwS","small":"style_small__CKzUi","tiny":"style_tiny__B36Cl","rounded":"style_rounded__Na7_a"};